<template>
  <CommonPopup
    v-model="visible"
    class="export_images_popup"
    height="100%"
    position="bottom"
    get-container="body"
    :show-footer="false"
    :z-index="102"
  >
    <ExportImages
      v-if="visible"
      :scene="scene"
      :plain-result-data="plainResultData"
      :liability-show-type="Number(liabilityShowType)"
      :is-show-interest-table="!!interestData"
      :theme-settings="themeSettings"
      :export-risk-has-interest-demo="exportRiskHasInterestDemo"
      :export-risk-has-bonus="exportRiskHasBonus"
      @screen-capture="(cb) => $emit('screen-capture', cb)"
      @openThemePicker="$emit('openThemePicker')"
      @openInterestSettingPopup="$emit('openInterestSettingPopup')"
      @cancel="cancel"
    />
  </CommonPopup>
</template>
<script>
import CommonPopup from '@/components/common/common-popup/index.vue'
import ExportImages from './index.vue'

export default {
  components: {
    CommonPopup,
    ExportImages
  },
  props: {
    value: Boolean,
    scene: Number,
    liabilityShowType: Number,
    plainResultData: Object,
    interestData: Object,
    themeSettings: {
      type: Object,
      default: () => ({})
    },
    exportRiskHasInterestDemo: {
      default: undefined,
      validator: v => v === undefined || typeof v === 'boolean'
    },
    exportRiskHasBonus: {
      default: undefined,
      validator: v => v === undefined || typeof v === 'boolean'
    }
  },
  data () {
    return {
      overlay: false,
      activeIndex: 0
    }
  },
  computed: {
    visible: {
      get () {
        if (this.value) {
          this.init()
        }
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      },
    }
  },
  methods: {
    init () {
      this.overlay = true
      this.addHistoryState()
    },
    addHistoryState() {
      if (window.history && window.history.pushState) {
        history.pushState(null, null, location.href)
        window.addEventListener('popstate', () => {
          this.visible = false
        }, false)
      }
    },
    cancel () {
      this.visible = false
      history.go(-1)
    }
  }
}
</script>


<style lang="postcss">
.export_images_popup {
  
}
</style>